import React from "react";
import SidebarTop from "../../molecules/SidebarTop/SidebarTop";
import SidebarMid from "../../molecules/SidebarMid/SidebarMid";
import SidebarBottom from "../../molecules/SidebarBottom/SidebarBottom";
import { SidebarMenuItemType } from "../../../services/helpers/types";
import { CurrentSidebarItemState } from "../../pages/MainPage/MainPage";

interface SidebarInnerListProps {
  isTabletView: boolean;
  sidebarItems: SidebarMenuItemType[];
  currentSidebarItem: CurrentSidebarItemState;
  isSidebarFullScreen: boolean;
  isSidebarLoading: boolean;
  isAiAssistantOpen: boolean;
  isDictationOpen: boolean;
  onAiAssistantOpen: () => void;
  onFullScreenOpen: () => void;
  onTabletOpen: () => void;
  onSearch: (searchValue?: string) => void;
  onPageSelect: (itemID?: number, shouldRefresh?: boolean) => void;
  onPageCreate: (itemID: number) => void;
  onSettingsClick: () => void;
  onEditToggle: () => void;
  onDictationOpen: () => void;
}

const SidebarInnerList = (props: SidebarInnerListProps) => {
  const {
    isTabletView,
    isSidebarFullScreen,
    sidebarItems,
    currentSidebarItem,
    isSidebarLoading,
    isAiAssistantOpen,
    isDictationOpen,
    onAiAssistantOpen,
    onFullScreenOpen,
    onTabletOpen,
    onSearch,
    onPageSelect,
    onSettingsClick,
    onPageCreate,
    onEditToggle,
    onDictationOpen,
  } = props;
  return (
    <div className="dui-sidebar-inner-list">
      <SidebarTop
        isTabletView={isTabletView}
        isSidebarFullScreen={isSidebarFullScreen}
        onFullScreenOpen={onFullScreenOpen}
        onTabletOpen={onTabletOpen}
        onSearch={onSearch}
      />
      <SidebarMid
        sidebarItems={sidebarItems}
        currentSidebarItem={currentSidebarItem}
        onPageSelect={onPageSelect}
        isLoading={isSidebarLoading}
        onPageCreate={onPageCreate}
      />
      <SidebarBottom
        isAiAssistantOpen={isAiAssistantOpen}
        isDictationOpen={isDictationOpen}
        onAiAssistantOpen={onAiAssistantOpen}
        onSettingsOpen={onSettingsClick}
        onEditToggle={onEditToggle}
        onDictationOpen={onDictationOpen}
      />
    </div>
  );
};

export default SidebarInnerList;
